import { jsx as _jsx } from "react/jsx-runtime";
import { Provider as JotaiProvider } from 'jotai';
import { EcommerceLoginProvider } from '../contexts/ecommerce-login';
export function AppProvider(_ref) {
  var children = _ref.children,
      defaultLogin = _ref.defaultLogin;
  return /*#__PURE__*/_jsx(JotaiProvider, {
    children: /*#__PURE__*/_jsx(EcommerceLoginProvider, {
      defaultLogin: defaultLogin,
      children: children
    })
  });
}